var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-basic-point-settings',{attrs:{"submit":_vm.submit,"role":"update"}})
}
var staticRenderFns = []

export { render, staticRenderFns }